var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export const SimpleSrcSet = (_a) => {
    var { src, width, title } = _a, props = __rest(_a, ["src", "width", "title"]);
    return (_jsx("img", Object.assign({ src: `https://images.66north.com/assets/${src}?auto=compress,format&q=70&w=${width}`, srcSet: `https://images.66north.com/assets/${src}?auto=compress,format&q=70&w=${width} 1x,
      https://images.66north.com/assets/${src}?auto=compress,format&q=70&w=${width * 3} 2x,
      https://images.66north.com/assets/${src}?auto=compress,format&q=70&w=${width * 4} 3x,
      `, alt: title }, props)));
};
//# sourceMappingURL=SimpleSrcSet.js.map